import {
	SalesActivityAutomationMetadataFilter as AutomationFilterMetadata,
	AutomationFiltersFieldsValues
} from "@/Contracts/Others/SalesActivity";
import { ZomentumEntities } from "@/Contracts/common";

export interface CriteriaProps {
	readonly filterMetadata: AutomationFilterMetadata[];
	readonly isLoading?: boolean;
	readonly criteria: AutomationFiltersFieldsValues;
	readonly onCriteriaUpdate: (
		criteria: AutomationFiltersFieldsValues,
		filterEntityType: ZomentumEntities | null
	) => void;
	readonly onAddCriteria: () => void;
	readonly entityType: ZomentumEntities | null;
	readonly showAddCriteria?: boolean;
	readonly allowedEntityTypes?: ZomentumEntities[];
}

export const allowedEntityTypesForDynamicSearch = [
	ZomentumEntities.Opportunity,
	ZomentumEntities.Client,
	ZomentumEntities.ClientContact,
	ZomentumEntities.VendorCompany,
	ZomentumEntities.VendorClient
];
